module.exports = __webpack_public_path__ + "img/pointtracker.2e412b1c.svg";